<template>
  <div>
    <input type="hidden" :value="code" :name="name" :id="id">
    <codemirror v-model="code" :options="mergedOptions"></codemirror>
  </div>
</template>

<script>
  import { codemirror } from 'vue-codemirror'
  import 'codemirror/mode/sql/sql.js'
  export default {
    components: {
      codemirror
    },
    props: {
      name: {
        type: String,
        default: ''
      },
      mode: {
        type: String,
        default: null
      },
      id: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      options: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    data () {
      return {
        code: this.value
      }
    },
    computed: {
      mergedOptions () {
        return {
          theme: 'base16-light',
          mode: this.mode,
          lineNumbers: true,
          tabSize: 2
        }
      }
    }
  }
</script>

